"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var decimal_js_1 = __importDefault(require("decimal.js"));

var lodash_1 = require("lodash");

var operators_1 = require("rxjs/operators");

var constants_1 = require("../constants");

function valueForType(value, type, schemaValue) {
  if (!lodash_1.isNil(schemaValue) && type === constants_1.FieldType.fixed) {
    return "" + schemaValue;
  }

  if (lodash_1.isNil(value) || type === constants_1.FieldType.reserved) {
    return '';
  }

  switch (type) {
    case constants_1.FieldType.float:
      // return float representation, all dollar amounts
      // will be received as cents to avoid float imprecision
      return new decimal_js_1.default(value).dividedBy(100).toFixed(2);

    case constants_1.FieldType.alphaNumeric:
    case constants_1.FieldType.numeric:
    case constants_1.FieldType.base64:
    default:
      // return value unchanged
      return "" + value;
  }
}

function padValue(_a) {
  var justified = _a.justified,
      length = _a.length,
      padWith = _a.padWith,
      value = _a.value;
  var padFunction = justified === constants_1.FieldJustification.left ? String.prototype.padEnd : String.prototype.padStart;
  return padFunction.call(value, length, padWith);
} // converts an object representation of a message into a
// fixed-length ascii string with fields of the appropriate
// length and with the required padding strings


function convertMessageWithSchema(messageContent, messageSchema) {
  var schemaEntries = Object.entries(messageSchema);
  return schemaEntries.reduce(function (acc, _a) {
    var fieldName = _a[0],
        fieldSchema = _a[1];
    var fieldContent = messageContent[fieldName];
    var _b = fieldSchema.justified,
        justified = _b === void 0 ? constants_1.FieldJustification.left : _b,
        length = fieldSchema.length,
        _c = fieldSchema.padWith,
        padWith = _c === void 0 ? ' ' : _c,
        type = fieldSchema.type,
        schemaValue = fieldSchema.value;
    var value = valueForType(fieldContent, type, schemaValue);
    var paddedValue = padValue({
      justified: justified,
      length: length,
      padWith: padWith,
      value: value
    });
    return acc.concat(paddedValue);
  }, '');
}

function prepare(messageContent, messageSchema) {
  var raw = convertMessageWithSchema(messageContent, messageSchema);
  return Buffer.from(raw, constants_1.Encoding.ascii);
}

exports.prepare = prepare;

function tryParseValue(key, value) {
  if (key === constants_1.ResponseKey.CRT) {
    var cardTypeDigits = parseInt(value.replace(/.*\[(\d+)\]/, '$1'), 10);
    return constants_1.CardType[cardTypeDigits] || value.replace(/\s+\[\d+\]/, '');
  }

  return value;
}

exports.tryParseValue = tryParseValue;

function parseDataUsingFunction(parseFunction) {
  return operators_1.map(parseFunction);
}

exports.parseDataUsingFunction = parseDataUsingFunction;

function reverseLookupMapForEnum(enumeration) {
  return new Map(Object.entries(enumeration).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    return [value, key];
  }));
}

exports.reverseLookupMapForEnum = reverseLookupMapForEnum;

function mapKeyToReadableKey(key) {
  // attempt to map key to a human-readable key name
  // fallback to the original key name if not found
  return constants_1.ResponseKey[key] || key;
}

exports.mapKeyToReadableKey = mapKeyToReadableKey;

function sendAck(writer, predicate) {
  if (predicate === void 0) {
    predicate = function predicate() {
      return true;
    };
  }

  return operators_1.tap(function (event) {
    if (predicate(event)) {
      writer(Buffer.from(constants_1.ResponseDelimiter.ACK));
    }
  });
}

exports.sendAck = sendAck;